import React, {Component} from 'react';
import {connect} from "react-redux";
import {schoolSelectors} from "../../store/school";
import PropTypes from 'prop-types';
import styled from "styled-components";
import {maxWidth, minHeight} from "styled-system";
import {Card, Flex, Text} from "rebass";
import {Span} from "../Base";
import {withFirebase} from "../Firebase";
import {  returnFilterString, returnWithRosterFilterString} from '../../utils';

// import {authSelectors} from "../../store/auth";
import moment from 'moment'

const WrapperCard = styled(Card)`
${minHeight}
${maxWidth}
min-width: 322px;
`

const Wrapper = styled(Flex)`
${minHeight}
//min-height: 91px;
`

class LiveCheckinCard extends Component {
	state = {
		title: '',
		creator: ''
	}

	async componentDidMount() {

		const {checkin, schoolInfo, type} = this.props;
		const title = await this.returnCheckinTitle(checkin, schoolInfo)
		if(type !== 'pinned'){
			this.fetchOwnerInfo()
		}
		this.setState({title: title})
	}

	returnCheckinTitle = async (checkin, school) => {
		const {firebase} = this.props;
		let result = ''
		if(checkin.type === 0){
			result = returnFilterString(checkin.filters, school)
			if(checkin.rosterFilter) {
				result = returnWithRosterFilterString(checkin.rosterFilter, result);
			}
		}
		if(checkin.type === 1){
			const roster = await firebase.roster(checkin.type_id).get()
			const data = roster.data()
			result = data ? data.name : ''
		}
		if(checkin.type === 3){
			let dorm = school.subDormMap[checkin.type_id]
			// console.log(checkin)
			// console.log(dorm)
			// console.log(school)
			if(dorm){
				result = dorm.name
			}
		}
		return result
	}

	fetchOwnerInfo = async () => {
		const {checkin} = this.props;

		try {

			if(checkin.is_faculty) {
				let creatorRef = await this.props.firebase.faculty(checkin.creator_uid).get()
				let data = creatorRef.data()
				// console.log(data)
				this.setState({creator: `${data.first_name} ${data.last_name}`})
			} else {
				let creatorRef = await this.props.firebase.student(checkin.creator_uid).get()
				let data = creatorRef.data()
				// console.log(data)
				this.setState({creator: `${data.first_name} ${data.last_name}`})
			}

		}catch (error) {

		}
	}

	render() {
		const {title, creator} = this.state;
		const {checkin, type} = this.props;
		const date = moment.unix(checkin.created_at).calendar();

		let showLive = false
		if(type === 'pinned' && checkin.live === true){
			showLive = true
		}
		return (
			<WrapperCard minWidth={['300px']} variant={type} minHeight={['91px']}>
				<Wrapper p={2} width={1} justifyContent={'center'} flexDirection={'column'} flexWrap={'wrap'}
				         minHeight={['91px']}>
					<Text ml={2} p={1} fontSize={'17px'} fontWeight={800}>
						{title} {showLive && <Span color={'meta'}>(Live)</Span>}
					</Text>

					<Text ml={2} p={1} fontSize={'10px'} fontWeight={600}>{type === 'pinned' ? 'Me': creator}</Text>
					<Text ml={2} p={1} fontSize={'10px'} fontWeight={600} color={'metaText'}>Started: {date}</Text>
				</Wrapper>

			</WrapperCard>
		);
	}
}

LiveCheckinCard.propTypes = {
	checkin: PropTypes.object,
	type: PropTypes.string
};

LiveCheckinCard.defaultProps = {
	type: 'pinned',
	checkin: {id: '1', name: "Check In", creator_uid: 'XXXX', is_faculty: true, updated_at: 1557431532, created_at: 1557431532, type: 0, type_id: '0' }
};

function mapStateToProps(state) {
	return {
		// schoolInfo: schoolSelectors.refreshSchool(state.school),
		loadingSchool: schoolSelectors.isLoading(state.school)
	}
}

export default withFirebase(connect(
	mapStateToProps,
)(LiveCheckinCard));
